import { formaters } from "vincent-utils";
import { trpc } from "../main/components/trpc.ts";
import { DateTime } from "luxon";
import _ from "underts";

const QuestionsMainContainer = () => {
  const questions = trpc.question.getAllQuestions.useQuery().data || [];

  const questionsSorted = _.sortBy(questions, (question) =>
    question.created_at.getTime()
  ).reverse();

  const formatDate = (date: Date | null) => {
    if (!date) return "-";
    return DateTime.fromJSDate(date).toFormat("dd/MM/yyyy HH:mm");
  };

  const formatNote = (note: 1 | 2 | 3 | 4 | 5 | null) => {
    if (note === null) return "-";
    return `${note}/5`;
  };

  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold mb-4">
        Questionnaires de satisfaction
      </h1>

      <div className="overflow-x-auto">
        <table className="min-w-full bg-white border border-gray-300">
          <thead className="bg-gray-100">
            <tr>
              <th className="px-4 py-2 text-left border-b border-gray-300 font-semibold">
                Date de création
              </th>
              <th className="px-4 py-2 text-left border-b border-gray-300 font-semibold">
                Nom du patient
              </th>
              <th className="px-4 py-2 text-left border-b border-gray-300 font-semibold">
                Prénom du patient
              </th>
              <th className="px-4 py-2 text-center border-b border-gray-300 font-semibold">
                Note choisie
              </th>
              <th className="px-4 py-2 text-center border-b border-gray-300 font-semibold">
                Lien Google cliqué
              </th>
              <th className="px-4 py-2 text-left border-b border-gray-300 font-semibold">
                Date de réponse
              </th>
            </tr>
          </thead>
          <tbody>
            {questionsSorted.length === 0 ? (
              <tr>
                <td colSpan={6} className="px-4 py-8 text-center text-gray-500">
                  Aucune question trouvée
                </td>
              </tr>
            ) : (
              questionsSorted.map((question) => (
                <tr key={question.id} className="hover:bg-gray-50">
                  <td className="px-4 py-2 border-b border-gray-200">
                    {formatDate(question.created_at)}
                  </td>
                  <td className="px-4 py-2 border-b border-gray-200 font-medium">
                    {question.name &&
                      formaters.capitaliseEveryFirstLetter(question.name)}
                  </td>
                  <td className="px-4 py-2 border-b border-gray-200">
                    {question.forename &&
                      formaters.capitaliseEveryFirstLetter(question.forename)}
                  </td>
                  <td className="px-4 py-2 border-b border-gray-200 text-center">
                    <span
                      className={`px-2 py-1 rounded text-sm font-medium ${
                        question.note === null
                          ? "bg-gray-100 text-gray-600"
                          : question.note <= 2
                            ? "bg-red-100 text-red-800"
                            : question.note === 3
                              ? "bg-yellow-100 text-yellow-800"
                              : "bg-green-100 text-green-800"
                      }`}
                    >
                      {formatNote(question.note)}
                    </span>
                  </td>
                  <td className="px-4 py-2 border-b border-gray-200 text-center">
                    <span
                      className={`px-2 py-1 rounded text-sm font-medium ${
                        question.google_link_clicked
                          ? "bg-blue-100 text-blue-800"
                          : "bg-gray-100 text-gray-600"
                      }`}
                    >
                      {question.google_link_clicked ? (
                        <span className="text-green-400">Oui</span>
                      ) : (
                        <span className="text-red-400">Non</span>
                      )}
                    </span>
                  </td>
                  <td className="px-4 py-2 border-b border-gray-200">
                    {formatDate(question.responded_at)}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {questions.length > 0 && (
        <div className="mt-4 text-sm text-gray-600">
          Total : {questions.length} question{questions.length > 1 ? "s" : ""}
        </div>
      )}
    </div>
  );
};
export default QuestionsMainContainer;
